<template>
  <div class="paypal-session">
    <div v-if="!isPaypalSigned" class="paypal-session__logged-out-wrapper">
      <p>
        <a @click.prevent="createPaypal">Sign in</a> to PayPal to connect your
        account.
      </p>
    </div>
    <div v-else class="paypal-session__logged-in-wrapper">
      <p class="paypal-session__logged-in-account">
        {{ paypalLabel }}
      </p>
      <p class="paypal-session__logged-in-action">
        <a @click.prevent="createPaypal">Disconnect</a> your account.
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const recurlyKey = process.env.VUE_APP_RECURLY_KEY

export default {
  name: 'PaypalSession',
  emits: ['handle-recurly-token'],
  data() {
    return {
      paypal: null,
    }
  },
  computed: {
    ...mapState({
      paymentInfo: state => state.subscriptions.paymentInfo,
    }),
    isPaypalSigned() {
      return this.paymentInfo?.payment_method === 'paypal_billing_agreement'
    },
    paypalLabel() {
      let text = "You're signed in to your PayPal account"
      text += this.paymentInfo?.paypal_email
        ? ` as ${this.paymentInfo?.paypal_email}`
        : ''
      return text
    },
  },
  created() {
    window.recurly.configure(recurlyKey)
  },
  methods: {
    createPaypal() {
      this.$emit('creating-paypal-instance', true)
      this.paypal = window.recurly.PayPal({
        display: { displayName: ' INE ' },
      })
      this.paypal.on('error', this.handlePaypalErrors)
      this.paypal.on('token', token => {
        this.$emit('handle-recurly-token', token)
      })
      this.paypal.start()
    },
    handlePaypalErrors(error) {
      if (error?.message) {
        return this.$store.dispatch('app/setError', error.message)
      }
      return this.$store.dispatch(
        'app/setError',
        'Something went wrong with PayPal. Please try again.'
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.paypal-session {
  color: var(--white);
  font-size: rem(14);
  line-height: 20px;
  font-weight: 500;

  p {
    margin: 0;
  }
  a {
    text-decoration: underline;
    cursor: pointer;
  }

  &__logged-in {
    &-wrapper {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
  }
}
</style>
